<template>
  <div
    class="sidebar sidebar-ontop"
    :data-color="activeColor"
    :data-image="backgroundImage"
    :data-background-color="backgroundColor"
    :style="sidebarStyle"
  >
    <div class="logo">
      <a href="/" class="simple-text logo-mini" target="_blank">
        <div class="logo-img">
          <img :src="logo" />
        </div>
      </a>
      <a href="/" class="simple-text logo-normal" target="_blank">
        <div style="margin-top: -10px">
          {{ title }}
        </div>
        <div style="" v-if="subtitle" class="md-body-1 side-subtitle">
          {{ subtitle }}
        </div>
      </a>
      <div class="navbar-minimize">
        <md-button
          id="minimizeSidebar"
          class="md-round md-just-icon md-transparent"
          @click="minimizeSidebar"
        >
          <i class="material-icons text_align-center visible-on-sidebar-regular"
            >more_vert</i
          >
          <i
            class="material-icons design_bullet-list-67 visible-on-sidebar-mini"
            >view_list</i
          >
        </md-button>
      </div>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <md-list class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>

        <template v-if="isExtranet">
          <li v-for="(link, index) in sidebarLinks" :key="link.name + index">
            <a class="nav-link" :href="link.path" target="_blank">
              <md-icon> {{ link.icon }} </md-icon>
              <p class="link-text">{{ link.name }}</p>
            </a>
          </li>
        </template>
      </md-list>
    </div>
  </div>
</template>

<script>
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "Freedom-7",
    },
    subtitle: {
      type: String,
      default: "Siniestros C",
    },
    rtlTitle: {
      type: String,
      default: "توقيت الإبداعية",
    },
    activeColor: {
      type: String,
      default: "green",
      validator: (value) => {
        const acceptedValues = [
          "",
          "purple",
          "azure",
          "green",
          "orange",
          "danger",
          "rose",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundImage: {
      type: String,
      default: "./img/sidebar-2.jpg",
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        const acceptedValues = ["", "black", "white", "red"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: require("@/assets/images/logo.jpg"),
    },
    // sidebarLinks: {
    //   type: Array,
    //   default: () => [],
    // },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
    isExtranet() {
      return [
        "Extranet",
        "Extranet_GeRe",
        "Extranet_JeAd",
        "Extranet_JeEl",
        "Extranet_JeCo",
      ].some((g) => this.$inGroup(g));
    },
    sidebarLinks() {
      return [
        {
          name: "Manual de Usuario Extranet",
          path: "https://www.freedom-7.com.mx/media/Manual_de_Usuario_de_Extranet.pdf",
          icon: "book",
        },
      ];
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style langs="scss" scoped>
.sidebar-ontop {
  z-index: 25;
}

.link-text {
  max-width: 100% !important;
  overflow-wrap: break-word !important;
  word-break: break-all !important;
}
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}

.side-subtitle {
  color: #bbb;
  margin-top: -5px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarPlugin/SideBar.vue